import * as types from "../actions/actionsTypes";

let initialState = {
  theme: 'Default',
  languages: [],
  features: {
    brands_enabled: true,
    learning_enabled: true,
    social_wall_enabled: true,
  },
  register: {
    shop: {
      retailer: true,
      shop_name: true,
      address: true,
      city: true,
    },
    person: {
      gender: true,
      first_name: true,
      last_name: true,
      birthdate: true,
      address: true,
      city: true,
      postal_code: true,
    },
    misc: {
      referral_code: true,
    },
  },
  shopEnabled: true,
};

const configReducer = (state = initialState, action) => {
  switch (action.type) {
    case types.SET_CONFIG:
      return {
        ...state,
        ...action.data,
      };

    case types.SET_SHOP_CONFIG:
      return {
        ...state,
        shopEnabled: action.data,
      };

    case types.RESET_CONFIG:
      return {
        ...state,
        languages: [],
        features: {
          brands_enabled: true,
          learning_enabled: true,
          social_wall_enabled: true,
        },
        register: {
          shop: {
            retailer: true,
            shop_name: true,
            address: true,
            city: true,
          },
          person: {
            gender: true,
            first_name: true,
            last_name: true,
            birthdate: true,
            address: true,
            city: true,
            postal_code: true,
          },
          misc: {
            referral_code: true,
          },
        },
        shopEnabled: true,
      };

    default:
      return state;
  }
};

export default configReducer;
